import React from 'react'
import styled from 'styled-components'

import { presets } from '../presets'

interface IImageProps {
  source: string
  preset:
    | 'preview'
    | 'input'
    | 'files'
    | 'fullscreen'
    | 'post'
    | 'editPost'
    | 'postInput'
    | 'editPostResponsive'
}

const Image = ({ source, preset }: IImageProps) => {
  if (preset === 'fullscreen') {
    return <FullscreenImage src={source} {...presets[preset].image} />
  }
  return <StyledImage src={source} {...presets[preset].image} />
}

export default React.memo(Image, (prevProps, nextProps) => {
  // Eğer source değişirse (yeni resim yüklendiğinde), bileşen güncellenmeli
  // Hem source hem de preset aynıysa, bileşen güncellenmemeli
  return prevProps.preset === nextProps.preset && prevProps.source === nextProps.source
})

const StyledImage = styled.img.attrs(
  (props: { maxWidth: string; maxHeight: string; borderRadius: string; objectFit: string }) =>
    props,
)`
  display: block;
  width: 100%;
  height: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  object-fit: ${({ objectFit }) => objectFit};
  border-radius: ${({ borderRadius }) => borderRadius};
`

const FullscreenImage = styled.img.attrs(
  (props: { maxWidth: string; maxHeight: string; borderRadius: string; objectFit: string }) =>
    props,
)`
  display: block;
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  object-fit: ${({ objectFit }) => objectFit};
  border-radius: ${({ borderRadius }) => borderRadius};
  width: auto;
  height: auto;
`
